"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordField = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _InputField = require("../InputField");
var _icons = require("./icons");
var styles = _interopRequireWildcard(require("./PasswordField.css"));
const _excluded = ["passwordShown", "toggleVisibility"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PasswordField = exports.PasswordField = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      passwordShown,
      toggleVisibility
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const inputType = React.useMemo(() => passwordShown ? 'text' : 'password', [passwordShown]);
  const icon = React.useMemo(() => passwordShown ? /*#__PURE__*/React.createElement(_icons.EyeCrossedIcon, null) : /*#__PURE__*/React.createElement(_icons.EyeIcon, null), [passwordShown]);
  return /*#__PURE__*/React.createElement(_InputField.InputField, (0, _extends2.default)({
    "data-name": "PasswordField"
  }, props, {
    ref: ref,
    type: inputType,
    addon: /*#__PURE__*/React.createElement("button", {
      className: styles['addon'],
      disabled: props.disabled,
      type: "button",
      onClick: toggleVisibility
    }, icon)
  }));
});
PasswordField.displayName = 'PasswordField';